const Service = {
    /*getPoistionLog: function(callback){
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();
        if(dd<10){ dd='0'+dd;} 
        if(mm<10){mm='0'+mm;} 
        var date = dd + '-' + mm + '-' + yyyy;
        
        fetch("http://tfm.4m1g0.com:1880/prices/?date=" + date)
            .then(response => response.json())
            .then((data) => {
                // eslint-disable-next-line
                console.log(data.slice(4,28));
                data.forEach((element, i, data) => {
                    data[i] = element / 1000000;
                });
                
                callback(data);
            });
    },*/

    getTrakables: function(callback){
        fetch("https://nodered.armriot.com/trackables/")
            .then(response => response.json())
            .then((data) => {
                var list = [];
                for (var k in data) {
                    list.push(data[k]);
                }
                callback(list);
            });
    },

    getPoints: function(callback){
        fetch("https://5jotas.4m1g0.com:1880/positionLog/?trackable=48544C60&start=2019-10-06&end=2019-12-20T09:43:01.406Z")
            .then(response => response.json())
            .then((data) => {
                var list = [];
                for (var k in data) {
                    list.push(data[k]);
                }
                callback(list);
            });
    },
    
}

export { Service as default}